var n=function(n,c,t){return n?c:t||""},c=function(n){return n.reduce((function(n,c){return c.expr?"".concat(n," ").concat(c.trueClass):c.falseClass?"".concat(n," ").concat(c.falseClass):n}),"")};export{n as addClassIf,c as addClassIfv2};
